<template>
  <div class="navbar_wrap">
    <div class="navbar_container">
      <div class="navbar_left">
        <img class="logo" src="@/assets/img/com/pc/logo.png" alt="智寰科技..." />
      </div>
      <div class="navbar_right">
        <ul class="nav_menu">
          <li :class="{ active: activeIndex === 0 }" @click="navigateTo(0)">首页</li>
          <li :class="{ active: activeIndex === 1 }" @click="navigateTo(1)">产品介绍</li>
          <li :class="{ active: activeIndex === 2 }" @click="navigateTo(2)">产品定价</li>
          <li :class="{ active: activeIndex === 3 }" @click="navigateTo(3)">下载产品</li>
          <li :class="{ active: activeIndex === 4 }" @click="navigateTo(4)">关于我们</li>
          <li :class="{ active: activeIndex === 5 } +' nav_tel'">
            联系方式
            <div class="telephone">试用热线:13260537580</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    }
  },
  methods: {
    navigateTo(index) {
      this.$emit('update:activeIndex', index)
      const routes = ['/', '/product', '/price', '/download', '/about']
      this.$router.push(routes[index])
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar_wrap {
  user-select: none;
  width: 100%;
  height: 64px;
  background: #fff;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;


  .navbar_container {
    width: 1280px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .navbar_left {
      display: flex;
      align-items: center;
      height: 100%;

      img {
        width: 156px;
        height: 36px;
        cursor: pointer;
      }
    }

    .navbar_right {
      display: flex;
      align-items: center;
      height: 100%;

      .nav_menu {
        display: flex;
        align-items: center;
        list-style: none;
        margin: 0;
        padding: 0;

        li {
          color: #333;
          font-size: 16px;
          font-weight: 400;
          padding: 0 32px;
          height: 64px;
          line-height: 64px;
          cursor: pointer;
          transition: color 0.2s, font-weight 0.2s;

          &.active,
          &:hover {
            color: #4681FF;
            font-weight: 600;
            background: transparent;
          }
        }
      }
    }
  }
}

.nav_tel {
  position: relative;
}

.telephone{
  display:none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% - 10px);
  width: 195px;
  text-align: center;
  background: #0869ff;
  padding: 4px 8px;
  line-height: 22px;
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 1px 1px 6px 4px #ebebeb;
}

.telephone::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 6px 6px 6px;
  border-style: solid;
  border-color: transparent transparent #0869ff transparent;
}

.nav_tel:hover .telephone{
  display:inline-block;
}
</style>